import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getNews, saveNews } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';

import { EditorState, convertToRaw, convertFromHTML, convertFromRaw, ContentState } from 'draft-js';
import { Editor } from 'react-draft-wysiwyg';

import '../../../node_modules/react-draft-wysiwyg/dist/react-draft-wysiwyg.css';
import draftToHtml from 'draftjs-to-html';
import htmlToDraft from 'html-to-draftjs';

import uploadImageCallBack from './upload';

class cmsAddNews extends Component {

    constructor(props) {
        super(props);
        this.state = {
          errors: [],
          mailDetail: '',
          mail_template:'',
          mail_content:'',
          mail_content:'',
          mail_subject:'',
          module:'',
          editorState: EditorState.createEmpty()
        };
        
        this.id = this.props.match.params.id ? this.props.match.params.id : '';
        //this.getMail = this.getMail.bind(this);
    }


    componentDidMount() {

      var THIS = this;
      
      if(this.id!='')
        this.getNews(this.id);

    }


    saveNews = ()=>{
          
       // let contentState = this.state.editorState.getCurrentContent();
        console.log("when saving..", this.state.consigne);


        let req = JSON.stringify({
            news_title:this.state.news_title,
            news_content: this.state.news_content,
            status:this.state.status,
            id:this.id
        })

        
        saveNews(req).then((response) => {
          
          if(response.status==1){

                alert(response.message);
                

          }else{
                alert(response.message);
          }
      
        });
       

    }

    getNews = () => {
      let ins = JSON.stringify({
        id:this.id
      });

      getNews(ins).then((res) => {
        if (res.status == 1) {
       
        const blocksFromHtml = htmlToDraft(res.detail.news_content);
        const { contentBlocks, entityMap } = blocksFromHtml;
        const contentState = ContentState.createFromBlockArray(contentBlocks, entityMap);
        const editorState = EditorState.createWithContent(contentState);

          this.setState({
            news_title: res.detail.news_title,
            news_content:res.detail.news_content,
            status:res.detail.status,
            editorState:EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(res.detail.news_content)))
          });

          this.setState({ 
            consigne:EditorState.createWithContent(ContentState.createFromBlockArray(convertFromHTML(res.detail.news_content))) 
          })

        }

      });
    }    


      handleChange = (e) => {
      this.setState({ [e.target.name]: e.target.value });
      };

      onChange = (editorState) => {
        //const contentState = editorState.getCurrentContent();
        //console.log("plain text", editorState.getCurrentContent().getPlainText());

        const contentState = draftToHtml(convertToRaw(editorState.getCurrentContent()))

        console.log("html", contentState);
        //const raw = convertToRaw(contentState);
        this.setState({
          consigne:editorState,
          news_content:contentState
        });
      }

    render() {

        const { mail_content, editorState, consigne} = this.state;


 
        return (
            <React.Fragment>
                <AdminLayout>
                    
                       <div class="col-12 grid-margin">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">News - Add New</h4>
                  <form class="form-sample">
                    
                    <div class="row">

                    
                      <div class="col-md-6">
                        <div class="form-group row">
                          <label class="col-sm-3 col-form-label">News Title</label>
                          <div class="col-sm-9">
                            <input type="text" class="form-control" name="news_title" value={this.state.news_title} onChange={this.handleChange} />
                          </div>
                        </div>
                      </div>
                       
                    </div>
                    
                    <div class="row">
                     
                      <div class="col-md-12">
                        <div class="form-group row">
                          <label class="col-sm-3 col-form-label">News Content</label>
                          <div class="col-sm-12">
                                <Editor
                                  //defaultEditorState={editorState}
                                  value={draftToHtml(convertToRaw(editorState.getCurrentContent()))}
                                  editorState={consigne}
                                  toolbarClassName="toolbarClassName"
                                  wrapperClassName="wrapperClassName"
                                  editorClassName="editorClassName"
                                  onEditorStateChange={this.onChange.bind(this)}
                                  //onEditorStateChange={(consigne) => {this.setState({consigne})}}
                                />
                          </div>
                           
                        </div>
                      </div>
                    </div>

                    <div class="row">

                    
                      <div class="col-md-6">
                        <div class="form-group row">
                          <label class="col-sm-3 col-form-label">Status</label>
                          <div class="col-sm-9">

                          <div class="form-group row">
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="status" id="inlineRadio1" value="1" checked={this.state.status === "1"}  onChange={this.handleChange} />
                              <label class="form-check-label" for="inlineRadio1">Publish</label>
                            </div>
                            <div class="form-check form-check-inline">
                              <input class="form-check-input" type="radio" name="status" id="inlineRadio2" value="0" checked={this.state.status === "0"}  onChange={this.handleChange} />
                              <label class="form-check-label" for="inlineRadio2">UnPublish</label>
                            </div>
                          </div>
                            
                          </div>
                        </div>
                      </div>
                       
                    </div>
                     
                    <div class="row">
                      <div class="col-md-12">
                        <div className="row mb-4 text-right">
                          <button type='button' id="btnSubmit"
                            className="btn btn-primary btn-sm" onClick={this.saveNews} style={{ display: "block", margin: "auto" }}>
                            Submit
                          </button>
                        </div>
                       
                      </div>
                    </div> 
                    
                  </form>
                </div>
              </div>
            </div>  


                </AdminLayout>
            </React.Fragment>
        )
    }
}



export default cmsAddNews;


// WEBPACK FOOTER //
// ./src/components/bewise/cmsAddNews.jsx